import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  appointMember,
  endAppointment,
  getCommitteeAppointments,
  getCommitteeHistory,
} from '@/lib/committee'
import type { CommitteePosition } from '@riverpark/types'

const KEYS = {
  appointments: ['committee', 'appointments'] as const,
  history: ['committee', 'history'] as const,
}

export function useCommitteeAppointments() {
  return useQuery({
    queryKey: KEYS.appointments,
    queryFn: getCommitteeAppointments,
  })
}

export function useCommitteeHistory() {
  return useQuery({
    queryKey: KEYS.history,
    queryFn: getCommitteeHistory,
  })
}

export function useAppointMember() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: {
      memberId: string
      position: CommitteePosition
      startedAt?: number
      notes?: string
    }) => appointMember(payload),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEYS.appointments })
      void qc.invalidateQueries({ queryKey: KEYS.history })
      // Invalidate member detail so the badge updates immediately
      void qc.invalidateQueries({ queryKey: ['members'] })
    },
  })
}

export function useEndAppointment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (appointmentId: string) => endAppointment(appointmentId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEYS.appointments })
      void qc.invalidateQueries({ queryKey: KEYS.history })
      void qc.invalidateQueries({ queryKey: ['members'] })
    },
  })
}
